export default "__VITE_PUBLIC_ASSET__a6b80542__"